import React from 'react';
import ScrollbarSvg from '../scrollbar/ScrollbarSvg';
import StripedTableRow from './StripedTableRow';
import PropTypes from 'prop-types';

const StripedTableScrollbarRow = ({
    isDynamic = false,
    isFirstRow = false,
    scrollPx,
    onScroll,
    gutterOffsetTop,
    maxHeight,
    border = '1px solid #d7d7d7',
    scrollableHeight,
    noOfRows = 0,
    onSizeChange,
    children,
    ...props
}) => (
    <StripedTableRow {...props}>
        {children}
        {isFirstRow && (
            <td
                id='table-campaign-types-scrollbar-gutter'
                rowSpan={noOfRows}
                style={{
                    backgroundColor: '#ffffff',
                    boxSizing: 'border-box',
                    borderRight: border,
                    borderBottom: border,
                    verticalAlign: 'top',
                    textAlign: 'center',
                    width: 16
                }}
            >
                <ScrollbarSvg
                    scrollPx={scrollPx}
                    onScroll={onScroll}
                    maxVisibleLength={maxHeight}
                    gutterOffset={gutterOffsetTop}
                    scrollableLength={scrollableHeight}
                    disabled={
                        !scrollableHeight ||
                        !maxHeight ||
                        scrollableHeight <= maxHeight
                    }
                    isDynamic={isDynamic}
                    onSizeChange={onSizeChange}
                />
            </td>
        )}
    </StripedTableRow>
);

StripedTableScrollbarRow.defaultProps = {
    isFirstRow: false,
    noOfRows: 0,
    border: '1px solid #d7d7d7'
};

StripedTableScrollbarRow.propTypes = {
    isFirstRow: PropTypes.bool,
    scrollPx: PropTypes.number,
    onScroll: PropTypes.func,
    maxHeight: PropTypes.number,
    border: PropTypes.string,
    scrollableHeight: PropTypes.number,
    noOfRows: PropTypes.number, // Required for safari
    onSizeChange: PropTypes.func
};

export default StripedTableScrollbarRow;
